import { useState } from 'react';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [setupMode, setSetupMode] = useState(false);
  const [setupName, setSetupName] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email || undefined, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      if (data.setup_required) {
        // Logged in with env password — show setup prompt after login
        onLogin(data.user, true);
      } else {
        onLogin(data.user, false);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSetup = async (e) => {
    e.preventDefault();
    if (!setupName || !email || !password) return;
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/auth/setup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: setupName, email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Setup failed');
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLogin(data.user, false);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#0f172a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'sans-serif', padding: 16,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 'bold', color: '#3b82f6', letterSpacing: '0.02em' }}>FieldCore</div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Field Operations Platform</div>
        </div>

        <div style={{ backgroundColor: '#1e293b', borderRadius: 12, padding: 28, border: '1px solid #334155', boxShadow: '0 8px 32px rgba(0,0,0,0.4)' }}>
          {!setupMode ? (
            <>
              <div style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: 17, marginBottom: 20 }}>Sign in</div>
              <form onSubmit={handleLogin}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 5 }}>Email</label>
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="you@company.com" autoComplete="email"
                    style={{ width: '100%', padding: '10px 12px', backgroundColor: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: 'white', fontSize: 14, boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ marginBottom: 18 }}>
                  <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 5 }}>Password</label>
                  <input
                    type="password" value={password} onChange={e => setPassword(e.target.value)}
                    placeholder="Password" autoComplete="current-password"
                    style={{ width: '100%', padding: '10px 12px', backgroundColor: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: 'white', fontSize: 14, boxSizing: 'border-box' }}
                  />
                </div>
                {error && <div style={{ color: '#f87171', fontSize: 13, marginBottom: 14 }}>{error}</div>}
                <button type="submit" disabled={loading || !password}
                  style={{ width: '100%', padding: '11px', backgroundColor: loading || !password ? '#1e3a5f' : '#2563eb', color: loading || !password ? '#64748b' : 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 'bold', cursor: loading || !password ? 'not-allowed' : 'pointer' }}>
                  {loading ? 'Signing in...' : 'Sign In'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                <button onClick={() => setSetupMode(true)} style={{ backgroundColor: 'transparent', border: 'none', color: '#3b82f6', fontSize: 12, cursor: 'pointer' }}>
                  First time setup →
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: 17, marginBottom: 6 }}>Create Admin Account</div>
              <div style={{ color: '#64748b', fontSize: 12, marginBottom: 20 }}>Only works if no users exist yet.</div>
              <form onSubmit={handleSetup}>
                {[
                  { label: 'Full Name', value: setupName, set: setSetupName, type: 'text', ph: 'Your full name' },
                  { label: 'Email', value: email, set: setEmail, type: 'email', ph: 'you@company.com' },
                  { label: 'Password', value: password, set: setPassword, type: 'password', ph: 'Choose a strong password' },
                ].map(({ label, value, set, type, ph }) => (
                  <div key={label} style={{ marginBottom: 14 }}>
                    <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 5 }}>{label}</label>
                    <input type={type} value={value} onChange={e => set(e.target.value)} placeholder={ph}
                      style={{ width: '100%', padding: '10px 12px', backgroundColor: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: 'white', fontSize: 14, boxSizing: 'border-box' }} />
                  </div>
                ))}
                {error && <div style={{ color: '#f87171', fontSize: 13, marginBottom: 14 }}>{error}</div>}
                <button type="submit" disabled={loading || !setupName || !email || !password}
                  style={{ width: '100%', padding: '11px', backgroundColor: '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 'bold', cursor: 'pointer', marginBottom: 10 }}>
                  {loading ? 'Creating...' : 'Create Admin Account'}
                </button>
                <button type="button" onClick={() => setSetupMode(false)}
                  style={{ width: '100%', padding: '9px', backgroundColor: 'transparent', border: '1px solid #334155', color: '#64748b', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                  ← Back to Sign In
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
